import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useOAuthLogin } from 'shared/hooks/use-oauth-login';
import useUser from 'shared/hooks/use-user';
import { INTEGRATIONS_API } from '../api';
import { AuthUrlInterface, SendZoomIntegrationCodeProps } from '../types';
export const useIntegration = t0 => {
  const $ = _c(18);
  const {
    onError,
    onSuccess,
    setIsLoading
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    fetcher: removeIntegrationFetcher
  } = useFetch(t2);
  const {
    openAuthWindow
  } = useOAuthLogin();
  let openZoomLogin;
  let sendZoomIntegrationCode;
  if ($[2] !== fetcher || $[3] !== onError || $[4] !== onSuccess || $[5] !== openAuthWindow || $[6] !== setIsLoading || $[7] !== user) {
    const subscribeOnMessageFromCallbackPage = authWindow => {
      const handleMessage = async event => {
        if (event.origin !== window.location.origin) {
          return;
        }
        const {
          code,
          error,
          state
        } = event.data;
        if (event.source !== authWindow) {
          return;
        }
        if (code && state) {
          ;
          try {
            await sendZoomIntegrationCode({
              code,
              state
            });
            onSuccess();
          } catch (t3) {
            const e = t3;
            onError(e as unknown as Error);
          }
        } else {
          if (error) {
            onError(new Error(error));
          }
        }
        window.removeEventListener("message", handleMessage);
      };
      window.addEventListener("message", handleMessage);
    };
    openZoomLogin = async () => {
      setIsLoading(true);
      const {
        url
      } = await fetcher(`${INTEGRATIONS_API}/zoom-integration/user/authorize`);
      setIsLoading(false);
      await openAuthWindow({
        locationHref: url,
        subscribeOnMessageFromCallbackPage,
        onError
      });
    };
    sendZoomIntegrationCode = async t4 => {
      const {
        code: code_0,
        state: state_0
      } = t4;
      if (!user) {
        return;
      }
      await fetcher(`${INTEGRATIONS_API}/zoom-integration/user/oauth-callback?code=${code_0}&state=${state_0}`);
    };
    $[2] = fetcher;
    $[3] = onError;
    $[4] = onSuccess;
    $[5] = openAuthWindow;
    $[6] = setIsLoading;
    $[7] = user;
    $[8] = openZoomLogin;
    $[9] = sendZoomIntegrationCode;
  } else {
    openZoomLogin = $[8];
    sendZoomIntegrationCode = $[9];
  }
  let t3;
  if ($[10] !== removeIntegrationFetcher || $[11] !== setIsLoading || $[12] !== user) {
    t3 = async disassociateEvents => {
      if (!user) {
        return;
      }
      setIsLoading(true);
      const query = disassociateEvents !== undefined ? `?disassociateEvents=${disassociateEvents}` : "";
      const url_0 = `${INTEGRATIONS_API}/zoom-integration/user/revoke${query}`;
      await removeIntegrationFetcher(url_0);
      setIsLoading(false);
    };
    $[10] = removeIntegrationFetcher;
    $[11] = setIsLoading;
    $[12] = user;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const removeIntegration = t3;
  let t4;
  if ($[14] !== openZoomLogin || $[15] !== removeIntegration || $[16] !== sendZoomIntegrationCode) {
    t4 = {
      openZoomLogin,
      sendZoomIntegrationCode,
      removeIntegration
    };
    $[14] = openZoomLogin;
    $[15] = removeIntegration;
    $[16] = sendZoomIntegrationCode;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};